module.exports = __webpack_public_path__ + "img/bfe11ac.jpg";